import _keyBy from 'lodash/keyBy'

import { CONFIG_ENABLE_EDD } from '@src/config/env'

import { EDDDetails, EDDProductType, VariantDetail } from '../../../services/eddService/eddService.types'
import { DAY_NAMES } from '../../../utils/constants'
import useEddExp from '../hooks/useEddExp'

const EDD_THRESHHOLD_DAYS = 5

export const getEDDDetails = (
  variantEDDDetails: number[] | undefined,
  eddDetails: EDDProductType | undefined,
  zipCode?: string,
): EDDDetails => {
  if (!CONFIG_ENABLE_EDD || !zipCode) {
    return {
      showEDD: false,
      isExpressShipping: false,
    }
  }

  let standardDeliveryEDD: EDDDetails | null = null

  variantEDDDetails?.forEach(variantEDDDetail => {
    const eddDetail: VariantDetail | undefined = eddDetails?.[variantEDDDetail]
    const inventoryLocations = eddDetail?.location_ids

    if (eddDetail) {
      const eddDetailMap = _keyBy(eddDetail.delivery_types, 'type')
      const delivery = eddDetailMap.LB_STANDARD
      if (
        delivery &&
        delivery.max_days <= EDD_THRESHHOLD_DAYS &&
        (!standardDeliveryEDD || !standardDeliveryEDD.max_days || standardDeliveryEDD.max_days > delivery.max_days)
      ) {
        standardDeliveryEDD = {
          ...delivery,
          inventoryLocations,
          showEDD: true,
          isExpressShipping: false,
        }
      }
    }
  })

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (standardDeliveryEDD) return standardDeliveryEDD

  return {
    showEDD: false,
    isExpressShipping: false,
  }
}

export const useEDDDetailFromSelectedOptions = (
  eddDetails: EDDProductType | undefined,
  selectedOptionsVariantIds: number[] | undefined,
  zipCode?: string,
) => {
  const bucket = useEddExp()
  return getEDDDetails(selectedOptionsVariantIds, eddDetails, zipCode, bucket)
}

export const generateEDDLabel = (eddDetails: EDDDetails | undefined) => {
  if (!eddDetails?.max_date || !eddDetails.showEDD) return

  let dateInDateStringFormat = eddDetails.max_date

  const dateRegex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/

  if (dateRegex.test(dateInDateStringFormat)) {
    dateInDateStringFormat += 'T00:00:00'
  }

  const date = new Date(dateInDateStringFormat)

  const day = date.getDay()
  const dayOfMonth = date.getDate()

  // Month names for formatted display
  const MONTH_NAMES = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']

  const label = `FREE delivery by ${DAY_NAMES[day]}, ${MONTH_NAMES[date.getMonth()]} ${dayOfMonth}`

  // if (eddDetails.max_days === 1) {
  //   label = `FREE delivery tomorrow, ${MONTH_NAMES[date.getMonth()]} ${dayOfMonth}`
  // }

  // if (eddDetails.max_days === 2) {
  //   label = `FREE 2-day delivery by ${DAY_NAMES[day]}, ${MONTH_NAMES[date.getMonth()]} ${dayOfMonth}`
  // }

  return label
}
